import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { Checkbox, Paper } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ClearIcon from "@mui/icons-material/Clear";
import { useTheme } from "@mui/styles";

import StyledAutoComplete from "../../../kit/AutoComplete";
import { numberOfChips } from "../../MyApps/utils";

const CustomMultiAutocompleteRapid = ({
  options,
  value,
  handleChange,
  keyField,
  placeholder = "Type and press enter",
  readOnly = false,
}) => {
  const theme = useTheme();
  const filter = createFilterOptions();

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  return (
    <StyledAutoComplete
      multiple
      id="tags-filled"
      options={options}
      value={value}
      isOptionEqualToValue={(option, value) => option === value || value === ""}
      freeSolo={!readOnly}
      disableCloseOnSelect={!readOnly}
      PopperProps={{
        // Move PopperProps here
        disablePortal: true,
      }}
      popupIcon={<KeyboardArrowDownIcon />}
      // renderTags={(value, getTagProps) => {
      //   const numberOfChip = numberOfChips();
      //   return (
      //     <>
      //       {value.slice(0, numberOfChip).map((option, index) => (
      //         <Chip
      //           variant="outlined"
      //           label={option}
      //           title={option}
      //           deleteIcon={
      //             <ClearIcon
      //               sx={{
      //                 color: `${theme.palette.form.text} !important`,
      //                 fontSize: `${theme.size[15]} !important`,
      //               }}
      //             />
      //           }
      //           {...getTagProps({ index })}
      //           style={{
      //             color: theme.palette.form.text,
      //             borderRadius: theme.size[4],
      //             borderColor: theme.palette.secondary.main,
      //             maxWidth: theme.size[120],
      //             width: value.length > 1 ? theme.size[70] : "auto",
      //             whiteSpace: "nowrap",
      //             overflow: "hidden",
      //             textOverflow: "ellipsis",
      //             padding: theme.size[0],
      //             height: theme.size[25],
      //           }}
      //         />
      //       ))}
      //       {value.length > numberOfChip &&
      //         `+${value.length - numberOfChip} more`}
      //     </>
      //   );
      // }}
      renderTags={() => {}}
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          style={{
            color: theme.palette.form.text,
            fontSize: theme.size[13],
            height: theme.size[40],
          }}
        >
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8, color: theme.palette.secondary.main }}
            checked={selected}
            disabled={readOnly}
          />
          {option?.inputValue?.trim()
            ? `Add "${option?.inputValue.trim()}"`
            : option}
        </li>
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        if (params.inputValue?.trim() !== "") {
          if (
            !filtered
              .map((elem) => elem.toLowerCase())
              .includes(params.inputValue.toLowerCase())
          ) {
            filtered.push({
              inputValue: params.inputValue,
              title: `Add "${params.inputValue}"`,
            });
          }
        }
        return filtered;
      }}
      disableClearable={!readOnly}
      getOptionLabel={(option) => (option?.title ? option.title : option)}
      onChange={(e, value) => {
        if (!readOnly) {
          const filteredData = value.find((elem) => typeof elem === "object");
          const validArray = value
            .filter((elem) => typeof elem !== "object")
            .map((elem) => elem?.trim())
            .filter((elem) => elem !== "");
          if (filteredData?.inputValue) {
            handleChange(
              keyField,
              [...validArray, filteredData?.inputValue],
              "multiple"
            );
          } else {
            handleChange(keyField, validArray, "multiple");
          }
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="filled"
          placeholder={placeholder}
          margin="normal"
          fullWidth
          sx={{
            marginTop: 0,
            marginBottom: 0,
            height: "2em !important",
          }}
          InputProps={{
            ...params.InputProps,
            readOnly, // Apply readOnly to the input field
          }}
        />
      )}
    />
  );
};

export default CustomMultiAutocompleteRapid;
